import { Box, Grid, Typography } from "@mui/material";
import React from "react";
import { useParams } from "react-router-dom";
import { ViewProductSlider } from "./ViewProductSlider";
import { ViewProductDetails } from "./ViewProductDetails";
import { getDocumentById } from "../../firebase/firebaseCrud";
import { useCart } from "../../context/cart-context";

export const ShopViewComponent = () => {
  const params = useParams();
  const { isLoading, setIsLoading } = useCart();

  const [product, setProduct] = React.useState("");

  const getProduct = async () => {
    const prods = await getDocumentById("product-list", params.id);
    setProduct(prods);
  };

  React.useEffect(() => {
    getProduct();
  }, [params.id]);

  // console.log("product", product);

  React.useEffect(() => {
    if (product === 0) {
      setIsLoading(true);
    } else {
      setIsLoading(false);
    }
  }, [product]);
  return (
    <React.Fragment>
      <Box className=" mx-auto place-items-center flex">
        <Grid
          container
          spacing={0}
          className=" place-content-center md:gap-2 py-16"
        >
          <Grid item xs={10} sm={5} md={5} lg={5} className="h-[500px]">
            <ViewProductSlider data={product} />
          </Grid>
          <Grid item xs={10} sm={6} md={6} lg={6} className="h-full ">
            <ViewProductDetails data={product} />
          </Grid>
        </Grid>
      </Box>
    </React.Fragment>
  );
};
